export default (store) => ({
  path : 'official/:officialId',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Official = require('./components').default

      /*  Return getComponent   */
      cb(null, Official)

    /* Webpack named bundle   */
    }, 'official')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Official/index.js